// src/App.js
import React, { useState } from 'react';
import MainMenu from './components/MainMenu';
import CharacterSelection from './components/CharacterSelection';
import Battle from './components/Battle';
import GameOver from './components/GameOver';
// src/App.js
import ValentinPanel from './components/ValentinPanel'; // Importación correcta
import './App.css';

const App = () => {
  const [gameState, setGameState] = useState('mainMenu'); // Estados: mainMenu, characterSelection, battle, gameOver, valentinPanel
  const [character, setCharacter] = useState(null);
  const [playerName, setPlayerName] = useState('');

  const handleStart = () => {
    setGameState('characterSelection');
  };

  const handleCharacterSelect = (selectedCharacter, name) => {
    setCharacter(selectedCharacter);
    setPlayerName(name);
    setGameState('battle');
  };

  const handleBattleEnd = (result) => {
    if (result === 'win') {
      setGameState('valentinPanel'); // Mostrar el panel de San Valentín
    } else {
      setGameState('gameOver'); // Mostrar la pantalla de Game Over
    }
  };

  const handleRestart = () => {
    setCharacter(null);
    setPlayerName('');
    setGameState('mainMenu');
  };

  return (
    <div className="App">
      {gameState === 'mainMenu' && <MainMenu onStart={handleStart} />}
      {gameState === 'characterSelection' && <CharacterSelection onSelect={handleCharacterSelect} />}
      {gameState === 'battle' && (
        <Battle
          character={character}
          playerName={playerName}
          onBattleEnd={handleBattleEnd}
        />
      )}
      {gameState === 'gameOver' && <GameOver onRestart={handleRestart} />}
      {gameState === 'valentinPanel' && <ValentinPanel onRestart={handleRestart} />}
    </div>
  );
};

export default App;